<template>
  <file-pond
  name="test"
    ref="pictureUpload"
    class-name="my-pond"
    v-bind:allow-multiple="allowMultiple"
    allow-file-type-validation="true"
    allowImageExifOrientation="true"
    accepted-file-types="image/jpeg, image/png"
    max-file-size="8MB"
    :files="myFiles"
    @updatefiles="updateFiles"
  />
</template>

<script>
// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

// Import styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginImageExifOrientation
);

export default {
  data: function () {
    return {
      myFiles: [],
    };
  },
  methods: {
    updateFiles(file) {
      this.myFiles = file;
      this.$emit("updatePendingFiles", this.$refs.pictureUpload.getFiles());
      // console.log(this.pictureUpload);
    },
  },
  components: {
    FilePond,
  },
  computed: {
    refPound: function () {
      return this.$refs.pictureUpload;
    },
  },
  props: {
    allowMultiple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
html {
  .filepond--root {
    margin-bottom: 0;
  }
  .filepond--credits {
    display: none;
  }

  .filepond--drop-label {
    color: rgb(156 163 175);
  }
  .filepond--label-action {
    text-decoration-color: rgb(107 114 128);
    color: rgb(107 114 128);
    font-weight: bold;
  }
  /* bordered drop area */
  .filepond--panel-root {
    background-color: rgb(243 244 246);
    border: 2px solid;
    border-color: rgb(229 231 235);

    border-radius: 6px;
  }

  @media screen and (max-width: 550px) {
    .filepond--drop-label label {
      font-size: 80%;
    }

    .filepond--file {
      font-size: 80% !important;
    }
  }

  &.dark {
    .filepond--drop-label {
      color: rgb(107 114 128);
    }
    .filepond--label-action {
      text-decoration-color: rgb(156 163 175);
      color: rgb(156 163 175);
    }
    /* bordered drop area */
    .filepond--panel-root {
      background-color: rgb(17 24 39);
      border-color: rgb(55 65 81);
    }
  }
}
</style>
